// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './ProfileImage.module.scss';

/** @typedef {{
  src: string,
  size?: number
}} ProfileImagePropsType */

/**
 * CSS has a default background image for this div/component, for the case where the `src`
 * is null. It shouldn't really ever be null though, so we'll make it a required prop.
 *
 * @type { React.ValidationMap<ProfileImagePropsType> }
 */
const propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};

/** @type { StatelessComponent<ProfileImagePropsType> } */
const ProfileImage = ({ src, size }) => {
  const propStyles = {
    width: size,
    height: size,
    backgroundSize: `${size}px ${size}px`,
  };

  return (
    <div className={styles.ProfileImage} style={propStyles}>
      {src && <img src={src} alt="profile" width={size} height={size} />}
    </div>
  );
};

ProfileImage.displayName = 'ProfileImage';
ProfileImage.propTypes = propTypes;

ProfileImage.defaultProps = {
  size: 95,
};

export default ProfileImage;
